const addProj = () => import(/* webpackChunkName: "herb" */ './addProj');
const indusEdit = () => import('./indusEdit');
const indexApp = () => import('./indexAppl.vue');
const indexAdmin = () => import('./indexAdmin');
const clusterEdit = () => import('./clusterEdit');
const smsHqEdit = () => import('./smsHqEdit');
const pubServBaseEdit = () => import('./pubServBaseEdit.vue');
const pubServPlatformEdit = () => import('./pubServPlatformEdit.vue');
const pubServSmallCompLoanEdit = () => import('./pubServSmallCompLoanEdit.vue');
const pubServTinyCompLoanEdit = () => import('./pubServTinyCompLoanEdit.vue');
const phosphogypsumEdit = () => import('./phosphogypsumEdit.vue');
const newEnergyAppl = () => import('./newEnergyAppl.vue');
const newEnergyEdit = () => import('./newEnergyEdit.vue');


//2023项目储备库管理
export default {
  routes: [
    {
      path: '/projlib/v2023/indexApp',
      name: 'proj_lib_v2023_index_App',
      component: indexApp,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/indexAdmin',
      name: 'proj_lib_v2023_index_Admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/addProj',
      name: 'proj_lib_v2023_add_proj',
      component: addProj,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/indusEdit',
      name: 'proj_lib_v2023_indus_edit',
      component: indusEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/clusterEdit',
      name: 'proj_lib_v2023_cluster_edit',
      component: clusterEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/smsHqEdit',
      name: 'proj_lib_v2023_sm_hq_edit',
      component: smsHqEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/pubServBaseEdit',
      name: 'proj_lib_v2023_pub_serv_base_edit',
      component: pubServBaseEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/pubServPlatformEdit',
      name: 'proj_lib_v2023_pub_serv_platform_edit',
      component: pubServPlatformEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/pubServSmallCompLoanEdit',
      name: 'proj_lib_v2023_pub_serv_small_comp_loan_edit',
      component: pubServSmallCompLoanEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/pubServTinyCompLoanEdit',
      name: 'proj_lib_v2023_pub_serv_tiny_comp_loan_edit',
      component: pubServTinyCompLoanEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/phosphogypsumEdit',
      name: 'proj_lib_v2023_phosphogypsum_edit',
      component: phosphogypsumEdit,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/newEnergyAppl',
      name: 'proj_lib_v2023_newEnergy_appl',
      component: newEnergyAppl,
      meta: {public: true}
    },
    {
      path: '/projlib/v2023/newEnergyEdit',
      name: 'proj_lib_v2023_newEnergy_edit',
      component: newEnergyEdit,
      meta: {public: true}
    }

  ]
}



// WEBPACK FOOTER //
// ./src/components/projLib/V2003/router.js